import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';

import { Interaction, Point, OffsetView } from '@dbk/ui-charts';

import { PALETTE } from '../../../../../../../src/constants';
import { Currency } from '../../../../../../../src/components/common/number';
import SimpleDate from '../../../../../../../src/components/common/date';
import styles from './interactions.styles';

const VERTICAL_OFFSET = 10;

function Interactions({ data, currency, selectedValue, onChange }) {
  return (
    <Interaction
      xAxis="x"
      selectedValue={selectedValue}
      onChange={onChange}
    >
      <Interaction.XGroup>
        <Interaction.VerticalLine
          top={VERTICAL_OFFSET}
          wrapper={Interaction.HideLink}
        />
        <Interaction.Flag
          top={VERTICAL_OFFSET}
          view={item => (
            <View
              style={styles.flag}
            >
              <SimpleDate
                renderProps={{
                  style: styles.flagDate,
                  size: 'small',
                }}
                value={item.date}
              />
              <Currency
                renderProps={{
                  style: styles.flagPrice,
                  size: 'small',
                }}
                value={item.price.value}
                currency={currency}
              />
            </View>
          )}
        />

      </Interaction.XGroup>
      {data.map((d, i) => (
        <Point
          key={i}
          dataIndex={i}
          renderPoint={({ x, y }) => (
            <OffsetView
              offsets={{
                left: x,
                top: y,
              }}
            >
              <Interaction.ProximityVisibility x={x} threshold={0}>
                <Interaction.Circle d={10} strokeWidth={0} fill={PALETTE.lineChartColor} />
              </Interaction.ProximityVisibility>
            </OffsetView>
          )}
        />
      ))}
    </Interaction>
  );
}

Interactions.propTypes = {
  data: PropTypes.array.isRequired,
  currency: PropTypes.string,
  selectedValue: Interaction.propTypes.selectedValue,
  onChange: PropTypes.func,
};

export default Interactions;
